// src/scripts/components/mega-menu.ts
var MegaMenu = class extends HTMLElement {
  constructor() {
    super();
    this.overlay = document.querySelector(".mega-menu__overlay");
    this.colourLinks = Array.from(this.querySelectorAll(".colour-link"));
  }
  connectedCallback() {
    this.handleSubmenuHovers();
    this.handleColourMenu();
  }
  handleColourMenu() {
    this.colourLinks.forEach((link) => {
      link.addEventListener("mouseenter", () => this.handleColourLink(link));
    });
  }
  // Hover image panel removed (2026-08 meeting fix A4); only the bold-on-hover state remains.
  handleColourLink(link) {
    this.colourLinks.forEach((link2) => {
      const text = link2.querySelector(".text");
      if (text) text.classList.remove("font-bold");
    });
    const text = link.querySelector(".text");
    if (text) text.classList.add("font-bold");
  }
  handleSubmenuHovers() {
    this.querySelectorAll(".with-submenu").forEach((element) => {
      var _a;
      element.setAttribute("role", "button");
      element.setAttribute(
        "aria-expanded",
        element.parentNode.hasAttribute("data-open")
      );
      if (element.nextElementSibling.getAttribute("id")) {
        element.setAttribute("aria-controls", element.nextElementSibling.id);
      }
      element.addEventListener("mouseenter", (event) => {
        const timeout = this.getAttribute("data-open") ? 0 : 150;
        setTimeout(() => {
          if (element.matches(":hover")) {
            element.setAttribute("aria-expanded", "true");
            element.parentNode.setAttribute("data-open", "true");
            this.setAttribute("data-open", "true");
            this.overlay.classList.add("active");
            this.preventHide = true;
          }
        }, timeout);
      });
      (_a = element.parentNode) == null ? void 0 : _a.addEventListener("mouseleave", (event) => {
        const timeout = 100;
        setTimeout(() => {
          var _a2;
          const parent = element.parentNode;
          if (!(parent == null ? void 0 : parent.matches(":hover"))) {
            element.setAttribute("aria-expanded", "false");
            (_a2 = element.parentNode) == null ? void 0 : _a2.removeAttribute("data-open");
            this.overlay.classList.remove("active");
            this.removeAttribute("open");
            this.preventHide = false;
          }
        }, timeout);
      });
    });
  }
};
customElements.define("mega-menu", MegaMenu);

// src/scripts/components/mobile-menu.ts
var MobileMenu = class extends HTMLElement {
  constructor() {
    super();
    this.links = Array.from(this.querySelectorAll(".menu-link.has-children"));
    this.menuTrigger = this.querySelector(
      ".mobile-menu__trigger"
    );
    this.slides = Array.from(
      this.querySelectorAll(".navigation__drawer-slide")
    );
    this.overlay = this.querySelector(
      ".mobile-menu__overlay"
    );
  }
  connectedCallback() {
    this.handleBackClick();
    this.handleSubNavs();
    this.handleMenuToggle();
  }
  toggleMenu() {
    const isOpen = this.getAttribute("data-open") === "true";
    this.setAttribute("data-open", isOpen ? "false" : "true");
  }
  handleMenuToggle() {
    this.menuTrigger.addEventListener("click", () => this.toggleMenu());
    this.overlay.addEventListener("click", () => {
      console.log("fire");
      return this.toggleMenu();
    });
  }
  handleBackClick() {
    this.slides.forEach((slide) => {
      slide.querySelector("#back").addEventListener("click", () => {
        slide.classList.remove("active");
        slide.parentElement.classList.remove("active");
      });
    });
  }
  handleSubNavs() {
    this.links.forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const link2 = e.target;
        const listItem = link2.parentElement;
        const slideId = link2.getAttribute("data-slide-id");
        listItem.classList.add("active");
        this.slides.forEach((slide) => {
          if (!slide)
            return;
          console.log(listItem, slide.id, slideId);
          if (slide.id === slideId) {
            slide.classList.add("active");
          } else {
            slide.classList.add("remove");
          }
        });
      });
    });
  }
};
customElements.define("mobile-menu", MobileMenu);

// src/scripts/utils/utils.ts
var nextArrow = '<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg width="20" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.19846 2.20215L7.03281 10.4L0.198459 18.5978C-0.103673 18.9607 -0.0540742 19.4988 0.30779 19.8015C0.669654 20.1042 1.20938 20.0551 1.51152 19.6927L8.8016 10.9474C8.9344 10.789 9 10.5944 9 10.4C9 10.2053 8.9344 10.0109 8.8016 9.8525L1.51152 1.10722C1.20939 0.744821 0.669922 0.695756 0.307791 0.99842C-0.0551391 1.30162 -0.104205 1.83868 0.19846 2.20215Z" /></svg></button>';
var prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg width="20" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.80154 17.7979L1.96719 9.60004L8.80154 1.40223C9.10367 1.0393 9.05407 0.50117 8.69221 0.198505C8.33035 -0.104159 7.79062 -0.0550929 7.48848 0.307305L0.198397 9.05258C0.0655979 9.21098 -1.52707e-06 9.40564 -1.55863e-06 9.60004C-1.59024e-06 9.79471 0.0655978 9.98911 0.198397 10.1475L7.48848 18.8928C7.79061 19.2552 8.33008 19.3042 8.69221 19.0016C9.05514 18.6984 9.1042 18.1613 8.80154 17.7979Z"/></svg></button>`;

// src/scripts/components/carousel.ts
var TestimonialCarousel = () => {
  const $testimonialCarousel = $(".testimonal-carousel");
  if (!$testimonialCarousel)
    return;
  const data = $testimonialCarousel.data();
  if (!data)
    return;
  $testimonialCarousel.slick({
    slidesToScroll: 1,
    dots: data.carouselDots,
    arrows: data.carouselArrows,
    slidesToShow: data.carouselDesktopSlides,
    // 2026-08 meeting fix A2: autoplay is timer-driven below (words/2 rule), not slick's fixed interval
    autoplay: false,
    prevArrow,
    nextArrow,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: data.carouselTabletSlides,
          arrows: false
        }
      },
      {
        breakpoint: 680,
        settings: {
          slidesToShow: data.carouselMobileSlides,
          centerPadding: "150px",
          dots: false,
          arrows: false
        }
      }
    ]
  });
  if (data.carouselAutoplay) {
    let timer = null;
    let hovered = false;
    let focused = false;
    let touching = false;
    const paused = () => hovered || focused || touching;
    const clear = () => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };
    const schedule = () => {
      clear();
      if (paused())
        return;
      const current = $testimonialCarousel.find(".slick-current").text() || "";
      const words = current.trim().split(/\s+/).filter(Boolean).length;
      const seconds = Math.max(4, Math.round(words / 2));
      timer = setTimeout(() => {
        const el = $testimonialCarousel[0];
        if (!paused() && el && document.contains(el) && $testimonialCarousel.hasClass("slick-initialized"))
          $testimonialCarousel.slick("slickNext");
      }, seconds * 1e3);
    };
    const sync = () => paused() ? clear() : schedule();
    $testimonialCarousel.on("afterChange", schedule);
    $testimonialCarousel.on("mouseenter", () => { hovered = true; sync(); });
    $testimonialCarousel.on("mouseleave", () => { hovered = false; sync(); });
    $testimonialCarousel.on("focusin", () => { focused = true; sync(); });
    $testimonialCarousel.on("focusout", (e) => {
      focused = !!(e.relatedTarget && $testimonialCarousel[0].contains(e.relatedTarget));
      sync();
    });
    $testimonialCarousel.on("touchstart", () => { touching = true; sync(); });
    $testimonialCarousel.on("touchend touchcancel", () => { touching = false; sync(); });
    $testimonialCarousel.on("destroy", clear);
    schedule();
  }
};
var ProductCarousel = () => {
  const $productCarousel = $(".product-carousel");
  if (!$productCarousel)
    return;
  const data = $productCarousel.data();
  if (!data)
    return;
  $productCarousel.slick({
    slidesToScroll: 1,
    dots: data.carouselDots,
    arrows: data.carouselArrows,
    slidesToShow: data.carouselDesktopSlides,
    prevArrow,
    nextArrow,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: data.carouselTabletSlides,
          centerMode: true,
          arrows: true
        }
      },
      {
        breakpoint: 680,
        settings: {
          slideToScroll: 1,
          slidesToShow: data.carouselMobileSlides,
          centerMode: true,
          dots: false,
          arrows: false
        }
      }
    ]
  });
};
var CollectionCarousel = () => {
  const $collectionCarousel = $(".collection-carousel");
  if (!$collectionCarousel)
    return;
  const data = $collectionCarousel.data();
  if (!data)
    return;
  $collectionCarousel.slick({
    slidesToScroll: 1,
    dots: data.carouselDots,
    arrows: data.carouselArrows,
    slidesToShow: data.carouselDesktopSlides,
    prevArrow,
    nextArrow,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: data.carouselTabletSlides,
          centerMode: true,
          arrows: true
        }
      },
      {
        breakpoint: 680,
        settings: {
          slideToScroll: 1,
          slidesToShow: data.carouselMobileSlides,
          centerMode: true,
          dots: false,
          arrows: false
        }
      }
    ]
  });
};
var HeroCarousel = () => {
  const $heroCarousel = $(".hero-carousel");
  if (!$heroCarousel)
    return;
  const params = new URL(window.location.href);
  const slide = parseInt(params.searchParams.get("active_slide"));
  $heroCarousel.slick({
    initialSlide: !slide ? 0 : slide - 1,
    dots: true,
    infinite: true,
    prevArrow: "",
    nextArrow
  });
};
(() => {
  HeroCarousel();
  TestimonialCarousel();
  ProductCarousel();
  CollectionCarousel();
})();
